import { OverlayService } from './../../../services/overlay.service';
import { PrebidService } from './../../../services/prebid.service';
import { SapiService } from './../../../services/sapi.service';
import { Auction } from './../../../interfaces/auction';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'auction-details-adapters',
	templateUrl: './auction-details-adapters.component.html',
	styleUrls: ['./auction-details-adapters.component.scss']
})

export class AuctionDetailsAdaptersComponent implements OnInit, OnChanges {
	@Input() auction: Auction;
	@Input() form: NgForm;
	publicationPrebidParams: any;
	hasAvailableSystems: boolean; // NB default undefined avoids flashing info message!

	constructor(
		private sapiService: SapiService,
		private prebidService: PrebidService,
		private overlayService: OverlayService) {
	}

	ngOnInit() {
		if (this.auction && !this.auction.prebidConfiguration) {
			this.auction.prebidConfiguration = {};
		} else if (this.auction && Array.isArray(this.auction.prebidConfiguration)) {
			this.auction.prebidConfiguration =
				(this.auction.prebidConfiguration.length > 0 && typeof this.auction.prebidConfiguration[0] === 'object')
					? this.auction.prebidConfiguration[0]
					: {};
		}

		if (this.prebidService.publicationPrebidParams) {
			this.handlePublicationPrebidParams(this.prebidService.publicationPrebidParams);
		} else {
			this.overlayService.setLoading(true);
			this.sapiService.getUrl('/publication/prebidParams').subscribe({
				next: (publicationPrebidParams: any) => {
					this.overlayService.setLoading(false);
					this.handlePublicationPrebidParams(publicationPrebidParams);
				},
				error: (err) => {
					this.overlayService.setLoading(false);
					if (err.status === 404) {
						this.publicationPrebidParams = null;
					}
				},
			});
		}
	}

	handlePublicationPrebidParams(publicationPrebidParams) {
		this.publicationPrebidParams = publicationPrebidParams;
		// check for enabled systems
		this.hasAvailableSystems = (Object.keys(this.publicationPrebidParams)
			.filter((key) => this.publicationPrebidParams[key] && !key.startsWith('__') && this.publicationPrebidParams[key].enabled).length > 0);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.auction && !changes.auction.firstChange) {
			if (this.auction && !this.auction.prebidConfiguration) {
				this.auction.prebidConfiguration = {};
			} else if (this.auction && Array.isArray(this.auction.prebidConfiguration)) {
				this.auction.prebidConfiguration = (this.auction.prebidConfiguration.length > 0 && typeof this.auction.prebidConfiguration[0] === 'object')
					? this.auction.prebidConfiguration[0]
					: {};
			}
		}
	}

	prebidParamsChanged() {
		this.formDirty();
	}

	formDirty() {
		if (this.form && this.form.form && this.form.form.markAsDirty) {
			this.form.form.markAsDirty();
		}
	}
}
